const ALERT_TYPE = {
  INFO: 'info',
  WARN: 'warning',
  WARNING: 'warning',
  ERR: 'error',
  ERROR: 'error'
}

function createAlertDisplay (alert, index) {
  const normalizedAlert = alert.trim()
  const prefixMatch = normalizedAlert.match(/^(WARNING|ERROR|INFO|WARN|ERR):?\s*/)
  const prefix = prefixMatch?.[1] || null
  const type = prefixMatch ? prefix : 'WARN'
  const title = prefixMatch
    ? normalizedAlert.slice(prefixMatch[0].length).trim()
    : normalizedAlert
  return {
    key: index,
    type: ALERT_TYPE[type],
    title
  }
}

export function createAlertsDisplay (alerts = []) {
  return alerts.map((alert, index) => createAlertDisplay(alert, index))
}
